import { ReactNode } from 'react'

import { Header } from '../Header'
import { SeasonEnds } from './SeasonEnds'
import { SeasonRankings } from './SeasonRankings'
import { SeasonStats } from './SeasonStats'
import { Footer } from './Footer'

const Content = ({ children }: { children?: ReactNode }) => {
  return (
    <section className="flex flex-col gap-2 py-1">
      <Header />
      <SeasonRankings />
      <SeasonStats />
      <SeasonEnds />
      {children}
    </section>
  )
}

export const Popover = () => (
  <Content>
    <Footer className="px-1" />
  </Content>
)

export const Modal = {
  Body: () => <Content />,
  Footer: () => <Footer />
}
